import React from 'react';
import PropTypes from 'prop-types';
import DateSwitcher from '../../../../common/DateSwitcher';
import config from '../../../../../config';

const WalkInListDatePicker = ({ currentDate, onChange }) => {
  return (
    <div className="walk-in-list-date-picker">
      <DateSwitcher
        changeDate={onChange}
        currentDate={currentDate}
        dateFormat={config.mediumDateFormat}
      />
    </div>
  );
};

WalkInListDatePicker.propTypes = {
  currentDate: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WalkInListDatePicker; 